import { render } from "./AppNavSettings.vue?vue&type=template&id=b4f7c992&scoped=true"
import script from "./AppNavSettings.vue?vue&type=script&lang=js"
export * from "./AppNavSettings.vue?vue&type=script&lang=js"

import "./AppNavSettings.vue?vue&type=style&index=0&id=b4f7c992&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-b4f7c992"

export default script